import { Component } from 'preact';
import { panLeft, panRight, panUp, panDown } from '../lib/worldmap';

export default class PanControl extends Component {
  onKeyDown (event) {
    let key = event.key;

    if (!key) {
      const keyCode = event.which || event.keyCode;

      switch (keyCode) {
        case 37:
        key = 'ArrowLeft';
        break;

        case 38:
        key = 'ArrowUp';
        break;

        case 39:
        key = 'ArrowRight';
        break;

        case 40:
        key = 'ArrowDown';
        break;
      }
    }
    
    switch (key) {
      case 'ArrowLeft':
      return panRight();

      case 'ArrowUp':
      return panDown();

      case 'ArrowRight':
      return panLeft();

      case 'ArrowDown':
      return panUp();
    }
  }

  render (props) {
    const { visible } = props;

    return <svg class={`pan${visible ? ' visible' : ''}`} tabindex={ visible ? 0 : -1 } onKeyDown={ this.onKeyDown } width="66" height="66" viewBox="-1 -1 66 66">
      <circle fill="white" r="32" cx="32" cy="32" />

      <g class="pan-button" onClick={ panDown } transform="rotate(45, 32, 32)">
        <path d="M2,31 a31,31 0 0 1 29,-29 v29 z" stroke="none" />
        <path d="M16,26 v-10 h10" fill="none" stroke-width="2" />
      </g>

      <g class="pan-button" onClick={ panLeft } transform="rotate(135, 32, 32)">
        <path d="M2,31 a31,31 0 0 1 29,-29 v29 z" stroke="none" />
        <path d="M16,26 v-10 h10" fill="none" stroke-width="2" />
      </g>

      <g class="pan-button" onClick={ panUp } transform="rotate(225, 32, 32)">
        <path d="M2,31 a31,31 0 0 1 29,-29 v29 z" stroke="none" />
        <path d="M16,26 v-10 h10" fill="none" stroke-width="2" />
      </g>

      <g class="pan-button" onClick={ panRight } transform="rotate(315, 32, 32)">
        <path d="M2,31 a31,31 0 0 1 29,-29 v29 z" stroke="none" />
        <path d="M16,26 v-10 h10" fill="none" stroke-width="2" />
      </g>
      
      {/* old iOS doesn't support <use/>
      <defs>
        <g id="pan-button">
          <path d="M2,31 a31,31 0 0 1 29,-29 v29 z" stroke="none" />
          <path d="M16,26 v-10 h10" fill="none" stroke-width="2" />
        </g>
      </defs>

      <use onClick={ panUp } href="#pan-button" transform="rotate(45, 32, 32)" />
      <use onClick={ panRight } href="#pan-button" transform="rotate(135, 32, 32)" />
      <use onClick={ panDown } href="#pan-button" transform="rotate(225, 32, 32)" />
      <use onClick={ panLeft } href="#pan-button" transform="rotate(315, 32, 32)" />
      */}
    </svg>;
  }
}



// WEBPACK FOOTER //
// ./components/PanControl.js